import { Component, OnInit, Input } from '@angular/core';
import { LenovoSupportService } from 'src/app/modules/hardware-scan/services/lenovo-support.service';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { KeyCode } from 'src/app/enums/key-code.enum';
import { WidgetHardwareScanItemComponentItems } from '../../../models/hardware-scan.interface';

@Component({
	selector: 'vtr-widget-hardware-scan-item',
	templateUrl: './widget-hardware-scan-item.component.html',
	styleUrls: ['./widget-hardware-scan-item.component.scss'],
})
export class WidgetHardwareScanItemComponent implements OnInit {
	@Input() items: WidgetHardwareScanItemComponentItems[];
	@Input() resultCodeText: string;
	@Input() isScanExecute = false;
	@Input() isRecoverExecute = false;
	@Input() isEnableViewResults = false;
	@Input() isViewLog = false;

	public isXsBreakpoint: boolean;
	public contactusUrl: string;

	constructor(
		private lenovoSupportService: LenovoSupportService,
		private breakPointObserver: BreakpointObserver,
		private logger: LoggerService
	) {}

	ngOnInit() {
		this.configureContactusUrl();
		this.getXsBreakpointStatus();
	}

	private async configureContactusUrl(): Promise<void> {
		await this.lenovoSupportService
			.getContactusUrl()
			.then((response) => {
				this.contactusUrl = response;
			})
			.catch((error) => {
				this.logger.exception('[WidgetHWScanItemComponent] configureContactusUrl', error);
			});
	}

	public openContactusPage(): void {
		window.open(this.contactusUrl);
	}

	/**
	 * Retrive if current observable breakpoint xSmall is matched and
	 * saves to isXsBreakpoint variable.
	 */
	private getXsBreakpointStatus(): void {
		this.breakPointObserver
			.observe([Breakpoints.XSmall])
			.subscribe((state: BreakpointState) => {
				this.isXsBreakpoint = state.matches;
			});
	}

	public shouldExpand(item: WidgetHardwareScanItemComponentItems) {
		const itemIsBeingScanned = this.isScanExecute && item.currentModule;
		const itemHasBeenScanned = this.isScanExecute && item.resultCode;
		const scanFinished = !this.isScanExecute && this.isViewLog;

		// Checks whether the item can be expanded when:
		if (
			this.isRecoverExecute || // running RBS
			this.isEnableViewResults // accessing the scan result page
		) {
			// accessing the previous results page
			return true;
		}

		// This condition will expand the item when a scan ends
		if (scanFinished) {
			return true;
		}

		if (itemIsBeingScanned && item.expandedStatusChangedByUser) {
			return item.expanded;
		} else if (itemIsBeingScanned) {
			return true;
		} else if (itemHasBeenScanned && item.expandedStatusChangedByUser) {
			return item.expanded;
		} else if (itemHasBeenScanned) {
			return false;
		}

		// If in the initial Hardware Scan page or scan in progress
		return item.expanded;
	}

	public setExpandStatusByUserOnClick(item: WidgetHardwareScanItemComponentItems, $event) {
		// Check if click has been performed in the collapse button
		const isExpectedElement = $event.target.attributes
			.getNamedItem('class')
			.value.split(' ')
			.includes('mat-expansion-indicator');

		if (isExpectedElement && (item.resultCode || item.currentModule)) {
			item.expandedStatusChangedByUser = true;
		}
	}

	public setExpandStatusByUserOnKeydown(item: WidgetHardwareScanItemComponentItems, $event) {
		const isExpectedKeyCode =
			$event.keyCode === KeyCode.RETURN || $event.keyCode === KeyCode.SPACE;

		if (isExpectedKeyCode && (item.resultCode || item.currentModule)) {
			item.expandedStatusChangedByUser = true;
		}
	}
}
